import React, { useState } from 'react';
import { Container, Row, Col, Modal } from 'react-bootstrap';
import Gallery1 from '../assets/images/Gallery/g1.webp';
import Gallery2 from '../assets/images/Gallery/g2.webp';
import Gallery3 from '../assets/images/Gallery/g3.webp';
import Gallery4 from '../assets/images/Gallery/g4.webp';
import Gallery5 from '../assets/images/Gallery/g5.webp';
import Gallery6 from '../assets/images/Gallery/g6.webp';
import Gallery7 from '../assets/images/Gallery/g7.webp';
import Gallery8 from '../assets/images/Gallery/g8.webp';
import Gallery9 from '../assets/images/Gallery/g9.webp';
import Gallery10 from '../assets/images/Gallery/g10.webp';
import Gallery11 from '../assets/images/Gallery/g11.webp';
import Gallery12 from '../assets/images/Gallery/g12.webp';
import Gallery13 from '../assets/images/Gallery/g13.webp';
import Gallery14 from '../assets/images/Gallery/g14.webp';
import Gallery15 from '../assets/images/Gallery/g15.webp';
import Gallery16 from '../assets/images/Gallery/g16.webp';
import Gallery17 from '../assets/images/Gallery/g17.webp';
import Gallery18 from '../assets/images/Gallery/g18.webp';

export default function Gallery() {
  const images = [Gallery1, Gallery2, Gallery3, Gallery4, Gallery5, Gallery6,Gallery7,Gallery8,Gallery9,Gallery10,Gallery11,Gallery12,Gallery13,Gallery14,Gallery15,Gallery16,Gallery17,Gallery18];

  const [show, setShow] = useState(false);
  const [currentImg, setCurrentImg] = useState('');

  const handleShow = (img) => {
    setCurrentImg(img);
    setShow(true);
  };

  const handleClose = () => setShow(false);

  return (
    <Container className="gallery-main my-5">
      <div className="text-center mb-4">
        <h2 className="center">Our <span>Gallery</span></h2>
      </div>
      <Row>
        {images.map((img, index) => (
          <Col md={4} sm={6} xs={12} className="mb-4" key={index}>
            <div
              className="gallery-card"
              onClick={() => handleShow(img)}
              style={{
                cursor: 'pointer',
                overflow: 'hidden',
                borderRadius: '12px',
                boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
              }}
            >
              <img
                src={img}
                alt={`Gallery ${index + 1}`}
                className="img-fluid gallery-img-main"
                style={{
                  transition: 'transform 0.3s',
                  width: '100%',
                  height: '250px',
                  objectFit: 'cover',
                }}
              />
            </div>
          </Col>
        ))}
      </Row>
          <div className="text-center mt-4">
  <a href="/gallery" className="gallery-view-more">View More →</a>
</div>
      {/* Modal for image view */}
      <Modal show={show} onHide={handleClose} centered size="lg">
        <Modal.Body className="p-0">
          <img src={currentImg} alt="Enlarged" className="img-fluid w-100" />
        </Modal.Body>
      </Modal>
    </Container>
  );
}
